export default __webpack_public_path__ + "static/media/marker2.1025bc2d.png";